/**
 * Email template for welcome emails
 */
export const getWelcomeEmailTemplate = (name: string) => {
  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Welcome to AISEOBlogGenerator</title>
      <style>
        body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #FFF8E7; }
        .header { background-color: #4A90E2; color: white; padding: 20px; text-align: center; border-radius: 5px 5px 0 0; }
        .content { background-color: #fff; padding: 20px; border-left: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0; }
        .footer { background-color: #f8fafc; padding: 20px; text-align: center; font-size: 12px; color: #64748b; border-radius: 0 0 5px 5px; border: 1px solid #e2e8f0; }
        .button { display: inline-block; background-color: #D9974B; color: white; text-decoration: none; padding: 10px 20px; border-radius: 5px; margin: 20px 0; font-weight: bold; }
        h1 { color: #fff; }
        h2 { color: #D9974B; }
        .accent { color: #D9974B; font-weight: bold; }
        .logo-section { text-align: center; margin-bottom: 15px; }
        .logo { width: 100px; height: auto; }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="logo-section">
          <img src="https://emp3.b-cdn.net/seoblogtool/png/dogwithpencil.png" alt="AISEOBlogGenerator Logo" class="logo" />
        </div>
        <h1>Welcome to AISEOBlogGenerator!</h1>
      </div>
      <div class="content">
        <p>Hi ${name},</p>
        <p>Welcome to <span class="accent">AISEOBlogGenerator</span>! We're thrilled to have you on board.</p>
        <p>Get ready to create amazing content that actually converts. Here are a few things you can do right away:</p>
        <ul>
          <li>Generate your first blog post</li>
          <li>Explore our pre-built writing styles</li>
          <li>Set up your Strike List to avoid AI clichés</li>
        </ul>
        <div style="text-align: center;">
          <a href="https://aiseobloggenerator.com/writer" class="button">Start Writing</a>
        </div>
        <p>If you have any questions, simply reply to this email. Our team is here to help!</p>
        <p>Best regards,<br>The AISEOBlogGenerator Team</p>
      </div>
      <div class="footer">
        <p>© ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.</p>
        <p><a href="https://aiseobloggenerator.com/privacy" style="color: #4A90E2;">Privacy Policy</a> | <a href="https://aiseobloggenerator.com/terms" style="color: #4A90E2;">Terms of Service</a></p>
      </div>
    </body>
    </html>
  `;

  const text = `
    Welcome to AISEOBlogGenerator!
    
    Hi ${name},
    
    Welcome to AISEOBlogGenerator! We're thrilled to have you on board.
    
    Get ready to create amazing content that actually converts. Here are a few things you can do right away:
    
    - Generate your first blog post
    - Explore our pre-built writing styles
    - Set up your Strike List to avoid AI clichés
    
    Start Writing: https://aiseobloggenerator.com/writer
    
    If you have any questions, simply reply to this email. Our team is here to help!
    
    Best regards,
    The AISEOBlogGenerator Team
    
    © ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.
    Privacy Policy: https://aiseobloggenerator.com/privacy
    Terms of Service: https://aiseobloggenerator.com/terms
  `;

  return {
    html,
    text
  };
};